
<template lang="html">



    <div>
        <button id="myButton" v-show="docs == 0" title="Adjuntar Documentos" @click="clickDocumentos" class="foo bar"> <v-icon :color="'#B3C9F1'"> {{'mdi-folder-upload'}}</v-icon></button>


        <vs-popup title="Solicitud de documentos" fullscreen :active.sync="val">
            <div class="container-fluid">

                <div class="row">

                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <vs-divider>
                            <span style="text-align:center;font-size: 15px"><strong>Adjuntar Documentos</strong></span>
                        </vs-divider>
                    </div>

                    <div class="col-12 col-sm-12 col-md-12">
                        <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-12"></div>
                            <div class="col-md-2 col-sm-2 col-xs-12">
                                <center>
                                    <span style="text-align:center;font-size: 15px"><strong>Reporte: </strong>{{datos.reporte}}-{{datos.indice}}</span>
                                </center>
                            </div>
                            <div class="col-md-4 col-sm-4 col-xs-12">
                                <center>
                                    <span style="text-align:center; font-size: 15px"><strong>Titular: </strong>{{nombre}}</span>
                                </center>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-12">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-12"></div>
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <center>
                                    <span class="text-center" style="text-align:center;font-size: 15px"><strong>Adjunte los archivos que se solicitan a continuación</strong></span>
                                    <br />
                                    <span style="text-align:center;font-size: 15px">Solo se aceptan PDF e imagenes JPG,JPEG,PNG</span>
                                </center>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-12">
                            </div>
                        </div>
                        <div v-if="active6">
                            <div class="row" v-if="factura">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <span style="text-align:center;"><strong>Factura:</strong></span>

                                    <v-file-input ref="file-input-factura"
                                                  v-model="datos.documentoFactura"
                                                  counter
                                                  accept=".pdf,.jpg,.png,.jpeg"
                                                  label="Seleccionar"></v-file-input>

                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                            <div class="row" v-if="tarjeta">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <span style="text-align:center;"><strong>Tarjeta de Circulación:</strong></span>
                                    <v-file-input ref="file-input-tarjeta"
                                                  v-model="datos.documentoTarjeta"
                                                  counter
                                                  accept=".pdf,.jpg,.png,.jpeg"
                                                  label="Seleccionar"></v-file-input>
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                            <div class="row" v-if="tenencia">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <span style="text-align:center;"><strong>Tenencia/Refrendo:</strong></span>
                                    <v-file-input ref="file-input-tenencia"
                                                  v-model="datos.documentoTenencia"
                                                  counter
                                                  multiple
                                                  accept=".pdf,.jpg,.png,.jpeg"
                                                  label="Seleccionar"></v-file-input>
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                            <div class="row" v-if="comprobante">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <span style="text-align:center;"><strong>Comprobante de Domicilio:</strong></span>
                                    <v-file-input ref="file-input-comprobante"
                                                  v-model="datos.documentoComprobante"
                                                  counter
                                                  accept=".pdf,.jpg,.png,.jpeg"
                                                  label="Seleccionar"></v-file-input>
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                            <div class="row" v-if="poliza">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <span style="text-align:center;"><strong>Póliza:</strong></span>
                                    <v-file-input ref="file-input-poliza"
                                                  v-model="datos.documentoPoliza"
                                                  counter
                                                  accept=".pdf,.jpg,.png,.jpeg"
                                                  label="Seleccionar"></v-file-input>
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                            <div class="row" v-if="ine">
                                <div class="col-md-3 col-sm-3 col-xs-12">
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                    <span style="text-align:center;"><strong>Identificación Oficial:</strong></span>
                                    <v-file-input ref="file-input-poliza"
                                                  v-model="datos.documentoIne"
                                                  counter
                                                  accept=".pdf,.jpg,.png,.jpeg"
                                                  label="Seleccionar"></v-file-input>
                                </div>
                                <div class="col-md-3 col-sm-2 col-xs-12">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-12">
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-12" style="margin-top:20px">
                                <vs-alert title="Error: " :active.sync="active2" color="danger">
                                    <span style="font-size: 15px;">{{mensaje}}</span>
                                </vs-alert>
                                <vs-alert title="Exito: " :active.sync="active1" color="success">
                                    <span style="font-size: 17px;">Se adjuntaron correctamente los archivos.</span>
                                </vs-alert>
                                <br />
                            </div>
                            <div class="col-md-3 col-sm-2 col-xs-12">
                            </div>
                        </div>
                    </div>

                </div>




            </div>

            <div class="card-footer text-center">
                <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center" style="margin-top: 5px;">
                    <vs-button @click="GuardarSeguimiento()" :disabled="disabledSave" color="primary">Aceptar</vs-button>
                    <vs-button color="danger" @click="Cancelar()" :disabled="disabledClean" type="filled" style="margin-left: 5px;">Cancelar</vs-button>
                </vs-col>


            </div>
            <input ref="search" disabled />
        </vs-popup>

    </div>

</template>

<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import reporte from '@/services/Reporte/reporte.service.js';

    export default {
        
        props: {
            nrreporte: String,
            pantalla: String
        },
        data: () => ({
            docs: 0,
            nombre: '',
            uslogin: '',
            factura: false,
            tarjeta: false,
            tenencia: false,
            comprobante: false,
            poliza: false,
            ine: false,
            val: false,
            active1: false,
            active2: false,
            active6: false,
            mensaje: '',
            reporteindice: '',
            disabledSave: false,
            disabledClean: false,
            resultado: [],
            datos: {
                documentoFactura: null,
                documentoTarjeta: null,
                documentoTenencia: [],
                documentoComprobante: null,
                documentoPoliza: null,
                documentoIne: null,
                files: new FormData(),
                reporte: '',
                indice: ''
            },
            value: null,
            opciones: []

        }),
        watch: {
            async 'datos.documentoFactura'(val) {

                if (val != null) {
                    this.active2 = false;
                }
            },
            async 'datos.documentoTarjeta'(val) {

                if (val != null) {
                    this.active2 = false;
                }
            },
            async 'datos.documentoTenencia'(val) {
                this.datos.files = new FormData();
                if (val.length > 0) {
                    this.active2 = false;
                }
                if (val.length > 5) {

                    this.active2 = true;
                    this.mensaje = 'No puede adjuntar más de 5 archivos';
                    this.datos.documentoTenencia = [];
                }
            },
            async 'datos.documentoComprobante'(val) {
                if (val != null) {
                    this.active2 = false;
                }
            },
            async 'datos.documentoPoliza'(val) {
                if (val != null) {
                    this.active2 = false;
                }
            },
            async 'datos.documentoIne'(val) {
                if (val != null) {
                    this.active2 = false;
                }
            },
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {
            async clickDocumentos() {
                //this.$vs.loading();
                this.active6 = true;
                this.disabledSave = true;
                this.disabledClean = true;
                this.active1 = false;
                this.active2 = false;
                this.val = true;
                this.factura = false;
                this.tarjeta = false;
                this.tenencia = false;
                this.comprobante = false;
                this.poliza = false;
                this.ine = false;
                this.datos.documentoFactura = null;
                this.datos.documentoTarjeta = null;
                this.datos.documentoTenencia = [];
                this.datos.documentoComprobante = null;
                this.datos.documentoPoliza = null;
                this.datos.documentoIne = null;
                this.opciones = await reporte.ObtenerDocumentosValidacion(this, this.datos);

                this.opciones.forEach((value, index) => {

                    if (value.doclave == 214) {//Factura
                        this.factura = true;
                    }
                    else if (value.doclave == 215) {//Tarjeta de circulación
                        this.tarjeta = true;
                    }
                    else if (value.doclave == 216) {//Tenencia
                        this.tenencia = true;
                    }
                    else if (value.doclave == 220) {//Comprobante de domicilio
                        this.comprobante = true;
                    }
                    else if (value.doclave == 1) {//Póliza
                        this.poliza = true;
                    }
                    else if (value.doclave == 24) {//INE
                        this.ine = true;
                    }
                });
                if (this.factura == false && this.tarjeta == false && this.tenencia == false && this.comprobante == false && this.poliza == false && this.ine == false) {
                    this.disabledSave = true;
                    this.disabledClean = true;
                }
                else {
                    this.disabledSave = false;
                    this.disabledClean = false;
                }
                this.nombre = await reporte.ObtenerNombreAsegurado(this, this.datos);


            },

            async GuardarSeguimiento() {
                this.disabledSave = true;
                this.disabledClean = true;
                if (this.factura || this.tarjeta || this.tenencia || this.comprobante || this.poliza || this.ine) {
                    if (this.datos.documentoFactura == null && this.datos.documentoTarjeta == null && this.datos.documentoTenencia.length == 0 && this.datos.documentoComprobante == null && this.datos.documentoPoliza == null && this.datos.documentoIne == null) {
                        this.mensaje = '';
                        this.active2 = true;
                        this.mensaje = 'Adjunte al menos un tipo de documento';
                        this.disabledSave = false;
                        this.disabledClean = false;
                        setTimeout(() => {
                            this.$refs.search.scrollIntoView();
                        }, 100);
                    }
                    else {

                        this.active2 = false;
                        this.$vs.loading();
                        setTimeout(async () => {
                            await reporte.GuardarSolicitudDocumentos(this, this.datos).then(response => {

                                if (response == true && this.datos.documentoTenencia.length > 0) {

                                    reporte.GuardarSolicitudDocumentosTenencia2(this, this.datos, this.datos.documentoTenencia, 216).then(response2 => {

                                        if (response2 == true) {
                                            reporte.insertarMovimiento(this, this.datos).then(response3 => {
                                                
                                                this.docs = response3;
                                                
                                                this.$vs.loading.close();
                                                this.active6 = false;
                                                this.active1 = true;
                                                

                                                setTimeout(() => {
                                                    this.active1 = false;
                                                    this.active2 = false;
                                                    this.mensaje = '';
                                                    this.disabledSave = false;
                                                    this.disabledClean = false;
                                                    this.val = false;
                                                    this.factura = false;
                                                    this.tarjeta = false;
                                                    this.tenencia = false;
                                                    this.comprobante = false;
                                                    this.poliza = false;
                                                    this.ine = false;
                                                    this.datos.documentoFactura = null;
                                                    this.datos.documentoTarjeta = null;
                                                    this.datos.documentoTenencia = [];
                                                    this.datos.documentoComprobante = null;
                                                    this.datos.documentoPoliza = null;
                                                    this.datos.documentoIne = null;
                                                }, 4000);

                                            });

                                        }

                                    });



                                }
                                else if (response == true && this.datos.documentoTenencia.length == 0) {
                                    
                                    reporte.insertarMovimiento(this, this.datos).then(response3 => {
                                        
                                        this.docs = response3;
                                        this.$vs.loading.close();
                                        this.active6 = false;
                                        this.active1 = true;

                                        
                                        setTimeout(() => {
                                            this.active1 = false;
                                            this.active2 = false;
                                            this.mensaje = '';
                                            this.disabledSave = false;
                                            this.disabledClean = false;
                                            this.val = false;
                                            this.factura = false;
                                            this.tarjeta = false;
                                            this.tenencia = false;
                                            this.comprobante = false;
                                            this.poliza = false;
                                            this.ine = false;
                                            this.datos.documentoFactura = null;
                                            this.datos.documentoTarjeta = null;
                                            this.datos.documentoTenencia = [];
                                            this.datos.documentoComprobante = null;
                                            this.datos.documentoPoliza = null;
                                            this.datos.documentoIne = null;
                                        }, 3000);

                                    });

                                }

                            });
                        }, 2000);
                    }
                }

            },
            Cancelar() {
                this.val = false;
                this.factura = false;
                this.tarjeta = false;
                this.tenencia = false;
                this.poliza = false;
                this.ine = false;
                this.comprobante = false;
                this.datos.documentoFactura = null;
                this.datos.documentoTarjeta = null;
                this.datos.documentoTenencia = [];
                this.datos.documentoComprobante = null;
                this.datos.documentoPoliza = null;
                this.datos.documentoIne = null;

            }

        },
        async mounted() {
            
            this.datos.reporte = this.nrreporte.split('-')[0];
            this.datos.indice = this.nrreporte.split('-')[1];

        },

    }
</script>

